import { NgRedux } from '@angular-redux/store';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import 'rxjs/add/observable/from';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { APP_CONFIG } from '../../api/config/app.config';
import { ModifyReservationDelegate } from '../../api/delegates/modify-reservation.delegate';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { useDefault } from '../../common/common';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { IAppState } from '../../store/interfaces/IAppState';

@Component({
  selector: 'reservation-changes-summary',
  templateUrl: './reservation-changes-summary.component.html'
})
export class ReservationChangesSummaryComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() shown: EventEmitter<boolean>;
  @Input() messages;
  state: IAppState;
  reservation: Reservation;
  hotel: Hotel;
  availableReservation: Reservation;
  showSummary: boolean;
  showRateDetails: boolean;
  availableResSubs: Subscription;
  private availableSub: Subject<boolean>;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig,
              private _ngRedux: NgRedux<IAppState>,
              private _modifyReservationDelegate: ModifyReservationDelegate) {
    this.shown = new EventEmitter();
    this.availableSub = new Subject();
  }

  ngOnInit() {
    this.reservation = null;
    this.availableReservation = null;
    this.showSummary = false;
    this.updateFromState();
    this._ngRedux.subscribe(() => {
      this.updateFromState();
    });
  }

  ngAfterViewInit(): void {
    this.availableResSubs = Observable.from(this.availableSub)
      .distinctUntilChanged().subscribe((event) => { this.shown.emit(event); })
  }

  ngOnDestroy(): void {
    this.availableResSubs.unsubscribe();
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    this.reservation = useDefault(this.state.reservation, new Reservation());
    this.hotel = useDefault(this.state.hotel, new Hotel());
    this.availableReservation = useDefault(this.state.availableReservation, null);
    this.showSummary = (this.availableReservation !== null);
    // only if showRateDetails is not true
    if (!this.showRateDetails) {
      this.availableSub.next(this.showSummary);
    }
  }

  confirmChanges() {
    this._modifyReservationDelegate.updateReservation();
  }

  cancelChanges() {
    this._modifyReservationDelegate.clearAllChanges();
  }

  switchDetails(flag: boolean) {
    this.showRateDetails = flag;
    this.shown.emit(!flag);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-changes-summary/reservation-changes-summary.component.ts